import * as React from 'react';
import * as styles from './ActionButtons.css';

export const ActionButtons: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['action-buttons']}>
      {React.Children.toArray(children).map((child, index) => (
        <div key={index} className={styles['button']}>
          {child}
        </div>
      ))}
    </div>
  );
};
